<template>
<div class="chapter">
<div class="inner_page">
<div class="grey">
<div class="x100">
<img alt="background" class="i300" src="image/GettyImages-12716382743.png"/>
</div>
<p class="_section-number-white" id="_idParaDest-5"><span class="com-rorohiko-pagestaker-style">5</span> <a id="_idTextAnchor003"></a> section 1</p>
<div class="x100">
<img alt="pentagram" class="i300" src="image/2.jpg"/>
</div>
<p class="section-title-white">the basics of a <br/>group practice</p>
<div class="x100">
<img alt="background" class="i300" src="image/GettyImages-1271638274.jpg"/>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// EWC-1.vue?2dfdd1f0